import toast from 'react-hot-toast'
import { IntlShape } from 'react-intl'

export const sanitizeGraphQLErrors = (
  errors: GraphqlError[],
  {
    messageCallback,
    messagePrefixKey,
    intl,
  }: {
    messageCallback?: (error: GraphqlError) => string,
    messagePrefixKey?: string,
    intl: IntlShape,
  },
) => (
  errors.map((error) => {
    if (messagePrefixKey && intl) {
      return sanitizeGraphQLError(error, intl, messagePrefixKey)
    }

    if (messageCallback) {
      return messageCallback(error)
    }

    return error.message
  })
)

export const sanitizeGraphQLError = (error: GraphqlError, intl: IntlShape, messagePrefixKey: string) => (
  intl.formatMessage({
    id: `${messagePrefixKey}${error.message}`,
    defaultMessage: intl.formatMessage({
      id: `common.errors.${error.message}`,
      defaultMessage: intl.formatMessage({ id: 'common.genericRequestError' }),
    }),
  })
)

export const showErrors = (messages: string[] | string) => {
  (Array.isArray(messages) ? messages : [messages]).forEach(showNotification)
}

const showNotification = (message: string) => {
  toast.error(message)
}

export const closeErrorNotifications = () => {
  toast.dismiss()
}

type GraphqlError = {
  message: string
}
